"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialProofMessage = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var social_proof_message_module_scss_1 = __importDefault(require("./social-proof-message.module.scss"));
var renderMessage = function (message) { return (react_1.default.createElement("div", { className: social_proof_message_module_scss_1.default['social-proof-message'] }, message)); };
var SocialProofMessage = function (_a) {
    var _b;
    var _c = _a.message, message = _c === void 0 ? '' : _c, fetchComponent = _a.fetchComponent;
    var _d = (0, react_1.useState)(message ? renderMessage(message) : null), Component = _d[0], setComponent = _d[1];
    (0, react_1.useEffect)(function () {
        if (message) {
            setComponent(renderMessage(message));
        }
        else if (fetchComponent) {
            setComponent(fetchComponent());
        }
    }, [message, fetchComponent]);
    return (Component && (react_1.default.createElement("div", { className: (0, classnames_1.default)(social_proof_message_module_scss_1.default['social-proof-message-container'], (_b = {},
            _b[social_proof_message_module_scss_1.default['social-proof-message-container__rendered-internally']] = message,
            _b)), "data-test": "jlds-social-proof-messages" }, Component)));
};
exports.SocialProofMessage = SocialProofMessage;
//# sourceMappingURL=SocialProofMessage.js.map